import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createLineType = ( {data} : {data: IPostNewLineType | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/LineTypes/InsertLineType`, data);
};

type QueryFnType = typeof createLineType;

type UseCreateLineTypeOptions = {
  data: IPostNewLineType | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateLineType = ({ config }: UseCreateLineTypeOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Είδους Γραμμής.`, 500);
            console.error('Couldnt create new LineType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllLineTypes"])
            addNotification(`Δημιουργήθηκε Νέο Είδος Γραμμής.`, 200);
            setIsNotificationVisible(true)  
          },
        ...config,
        mutationFn: createLineType,
    })
}